export default "__VITE_ASSET__C6Gwd2t6__"